export const SELECT_TOOL ="SELECT_TOOL";
export const CHANGE_SIZE ="CHANGE_SIZE";
export const CHANGE_COLOR ="CHANGE_COLOR";
export const RESET_CANVAS = "RESET_CANVAS";
export const SAVE_CANVAS = "SAVE_CANVAS";
export const IMAGE_STAMP = "IMAGE_STAMP";



/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/